import { useFormikContext } from "formik";
import React from "react";
import { FormikContextProps } from "../../../../../types/common/form";
import { IPatientAdmission } from "../../../../../types/patient/patientAdmission";
import InputField from "../../../../common/form/input/InputField";
import { H5 } from "../../styles";
import { Box } from "@mui/material";

const PatientAdmissionTitleAndInput = ({
  title,
  placeholder,
  name,
  ...rest
}: {
  title: string;
  placeholder: string;
  name: string;
  [x: string]: any;
}) => {
  const { values, setFieldValue }: FormikContextProps =
    useFormikContext<IPatientAdmission>();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value);
  };

  return (
    <>
      <Box>
        <H5>{title}</H5>
        <InputField
          className="pd-x-12 form-control"
          name={name}
          placeholder={placeholder}
          value={values?.[name]}
          onChange={inputHandler}
          {...rest}
        />
      </Box>
    </>
  );
};

export default PatientAdmissionTitleAndInput;
